
  import { KanziEnvironmentModel, CUSTOMERTYPES } from '@kanzi-apes/kanzi-models';
  export const environment: KanziEnvironmentModel = {
    production: false,
    kongTenantApi: '',
    kongApi: 'https://api-gco-staging.technoapes.io/',
    wmsKongApi: '',
    helpdeskUrl: '',
    kongTrackingFile: 'https://api-gco-staging.technoapes.io/logistics/tracking-files/',
    apesPdfCreatorApi: 'https://apes-pdf-creator.technoapes.io/pdf-creator',
    qsApiUrl: '',
    qsApiUrlCommon: 'https://apes-qs-embed-api.technoapes.io/',
    bucket_image_storage: '',
    nodeRedApi: '',
    socketIOServer: '',
    noderedCustomer: '',
    flightReportApiUrl: '',
    tokenFlightReport: '',
    gmtZone: '',
    isQuantity: false,
    tenantId: '478cc2b9',
    filterByLocation: true,
    useEanAsId: false,
    formats: {
      date: 'MM/DD/YYYY',
    },
    apiModules: {
      auth: 'auth/',
      authToken: 'token/login/',
      config: 'core_config/',
      inventory: 'inventory/',
      operations: 'operations/',
      rfid: 'rfid/',
      audits: 'inventory/audits/',
      logistics: 'logistics/',
      customers: 'customers/',
      integrations: 'integrations/',
      maintenance: 'maintenance/',
      stock: '',
      invoicing: 'invoicing/',
    },
    configUI: { mainMenuStyle: 'static', scale: 12 },
    assets: {
      logo: 'apes_logo.png',
      background: '',
      root:  'assets/',
      rootClient: '',
      paths: {
        css: 'css/',
        logos: 'images/logos/',
        backgrounds: 'images/backgrounds/',
        js: 'js/',
      },
    },
    modules: {
      customerType: 'STOCK_MANAGEMENT',
      automaticPrinting: false,
      dashboards: false,
      isEnableButtonExternalId: false,
      editContacts: true,
      discountsContacts: false,
      disabledCreateContacts: false,
      isFilterWerehouse: false,      
      contacts: true,
      contactsParams: true,
      products: {
        parent: true,
        products: true,
        assets: false,
        maintenanceTrace: false,
        filterTypeSku: false,
        setProperties: false,
        enableItemActivation: true,
        isDisabledCreateProduct: false,
        deleteProduct: false,
        editProducts: true,
        propsRequired:false,
        aditionalParamsInactiveTags: false,
        inactiveTagsAccions: true,
        activeComments: true,
        clientEan13: true,
        loadProductGroups: true,
        loadMasterFile: true,
        setImagesProduct: false,
      },
      inventories: {
        parent: true,
        products: true,
        assets: false,
        booking: false,
        bookingCreate: false,
        bookingList: false,
        hideColumnsSummary: false,
      },
      moves: {
        parent: true,
        dashboards: false,
        moves: true,
        sales: false,
        price: false,
      },
      nodes: {
        nodeTypes: [],
      },
      production: {
        parent: true,
        productionOrder: false,
        productionLocationType: 'WAREHOUSE',
        purchaseOrder: false,
        purchaseLocationType: 'WAREHOUSE',
        printOrder: false,
        filterOrder: false,
        external_id: false,
        by_ean: true,
        productionOrderIdHide: false,
        hideTagTemplate: true,
        enabledInventoryProps: false,
        productionOrderProperties: false,
        purchaseOrderProperties: false,
        loadMasterFile: true,
      },
      purchaseOrders:{
        parent: true,
        loadMasterFile: true,
      },
      printOrders:{
        generatePrintFile: true,
        printAgent: true,
        printAgentUrl: '',
        printAgentSocketUrl: 'http://localhost:5000',
        defaultPrinterIp: '',
      },
      operations: {
        parent: false,
        storeOrder: false,
        storeOrderTypes: true,
        distributionOrder: false,
        workOrder: { 
          parent: true, 
          reasignCreateNewOrder: false, 
          loadPackingsFile: true
        },
        packings: false,
        dispatchPacks: true,
        budgets: false,
        booking: false,
        woAssignsLeader:false
      },
      storeOrders: {
        parent: true,
        loadMasterFile: true,
      },
      audits: {
        parent: false,
        calendar: false,
        products: false,
        assets: false,
        typeAuditProps: 'DEFAULT',
        summaryDetail: true,
        lossControlOption: true,
        auditByProducts: true,
      },
      logisticPacking: {
        parent: false,
        list: false,
        listStates: false,
        create: false,
        initialStateForValidation: 'FILLED',
        bulkCreatePackings: false,
        bulkPrintAgent: false,
        printAgentSocketUrl: 'http://localhost:5000',
        },
      logistics: {
        parent: false,
        shippingOrders: false,
        trackOrderCreate: false,
        trackings: false,
        printers: false,
        pickingFile: false,
      },
      alerts: false,
    },
  }